import axios from 'axios';
import moment from 'moment';
import router from '../router/index';
import store from '../store/index';

// API URL
const apiUrl = process.env.VUE_APP_API_URL;

// HTTP without authentication
export const httpNoAuth = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'national-id': process.env.VUE_APP_NATIONAL_ID
  },
});

// HTTP with authentication
export const httpAuth = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'national-id': process.env.VUE_APP_NATIONAL_ID
  },
});

export const httpPin = axios.create({
  baseURL: process.env.VUE_APP_PIN_URL,
  headers: {
    'Content-Type': 'application/json',
    publishable_api_key: process.env.VUE_APP_PIN_PK,
  }
});

// Handle Refresh Token
httpAuth.interceptors.request.use((config) => {
  const originalRequest = config;
  const now = moment().valueOf();
  const expiry = store.getters['user/expiry'];
  const userId = store.getters['user/userId'];
  const refreshToken = store.getters['user/refreshToken'];

  // Token expired or about to expire
  if (expiry - 300 <= now) {
    return httpNoAuth.post('/assemble/api/v1/account/portal/authorize', {
      refresh_token: refreshToken,
      user_id: userId,
    }).then((response) => {
      store.commit('user/login', response.data);

      // Update Auth Header
      const token = store.getters['user/accessToken'];
      const authheader = `${userId}:${token}`;
      const encodedString = btoa(authheader);
      originalRequest.headers.Authorization = `Bearer ${encodedString}`;
      // originalRequest.headers['active-role'] = userStore.getters.activeRoleId;
      return originalRequest;
    }).catch((e) => {
      store.commit('user/logout');
      // Check if current route is a custom branding route
      const currentPath = router.currentRoute.path;
      const customBrandingMatch = currentPath.match(/^\/c\/([^/]+)\/([^/]+)/);

      if (customBrandingMatch) {
        const [, entityLevel, entityName] = customBrandingMatch;
        router.push(`/c/${entityLevel}/${entityName}/login`);
      } else {
        router.push('/login');
      }
      return e;
    });
  // eslint-disable-next-line no-else-return
  } else {
    // Update Auth Header
    const accessToken = store.getters['user/accessToken'];
    const authheader = `${userId}:${accessToken}`;
    const encodedString = btoa(authheader);
    originalRequest.headers.Authorization = `Bearer ${encodedString}`;
    // originalRequest.headers['active-role'] = userStore.getters.activeRoleId;
    return originalRequest;
  }
}, (err) => Promise.reject(err));

// Handle Global Error Handler
httpAuth.interceptors.response.use((response) => response, (error) => {
  const { status } = error.response || { status: 520 };

  if (status === 401) {
    // Not Authorized, redirect to login
    store.commit('user/logout');
    store.commit('loading', false);
    // Check if current route is a custom branding route
    const currentPath = router.currentRoute.path;
    const customBrandingMatch = currentPath.match(/^\/c\/([^/]+)\/([^/]+)/);

    if (customBrandingMatch) {
      const [, entityLevel, entityName] = customBrandingMatch;
      router.push(`/c/${entityLevel}/${entityName}/login`);
    } else {
      router.push('/login');
    }
  }

  if (status === 520) {
    // Unknown error handler
    throw new Error(`An unexpected error happened: ${error}`);
  }

  return Promise.reject(error);
});
